module.exports = __webpack_public_path__ + "static/media/nz.a8f100c7.svg";